
export const initialValues = {
  brandName: "",
  brandCode: "",
  activeStatus: 1,

}